import { Store } from 'redux';
import { BellaDispatch } from '../../redux/store';
import StateInterface from '../../redux/types';
import { fetchUserLastBoughtProduct } from '../../redux/user/lastBoughtProduct/actions';
import BrazeClient, { BRAZE_CLIENT_CONNECTED_TO_STORE, BrazeEvents } from 'AppShell/Braze/BrazeClient';

export const connectToStore = (brazeClient: BrazeClient, store: Store<StateInterface>) => {
    const dispatch = <BellaDispatch>store.dispatch;
    store.subscribe(() => {
        const { appShellLogin } = store.getState();
        if (appShellLogin.isLoggedIn && appShellLogin.data?.loginHash) {
            brazeClient.setUser(appShellLogin.data.loginHash);
        }
    });
    store.dispatch({ type: BRAZE_CLIENT_CONNECTED_TO_STORE });
    // later we could subscribe to events from brazeClient and dispatch some redux actions here.

    brazeClient.subscribeEvent(BrazeEvents.TRIGGER_RATE_YOUR_PRODUCT, (payload?: { messageId: string }) => {
        if (!brazeClient.shouldShowBrazePopup()) {
            return;
        }
        // fetch user last product;
        const ratingMessageId = payload?.messageId;
        dispatch(fetchUserLastBoughtProduct(ratingMessageId || ''));
    });
};

export default {
    connect: connectToStore,
};
